export default function SidebarContainer({ isOpen, onClose, children, isCompact = false }) {
  return (
    <>
      {/* Overlay pour mobile - ferme la sidebar au clic */}
      {isOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/50 lg:hidden animate-fade-in"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      <aside
        className={`fixed left-0 top-0 z-40 h-screen bg-gradient-to-b from-teal-700 to-teal-800 text-white flex flex-col py-2 transition-all duration-300 ease-in-out ${
          isOpen ? 'translate-x-0 animate-slide-in-left' : '-translate-x-full'
        } lg:translate-x-0 ${isCompact ? 'w-15' : 'w-60'}`}
      >
        {children}
      </aside>
    </>
  );
}
